import React, { useState, useEffect } from "react";

import "../css/PopupCGCOOLentesContacto.css";

import InputData from "../../components/InputData";
import InputTextArea from "../../components/InputTextArea";
import ButtonIconH from "../../components/ButtonIconH";
import Dropdown from "../../components/Dropdown";
import { post } from "../../js/post";
import { userData, selectedOptic } from "../../js/utils";

const OPTOMETRIST_DROPDOWN_ID = "popup-cgcoolc-optometrist";
const NORMAS_TEXTAREA_ID = "popup-cgcoolc-normas";

const IDIOMA_OPTIONS = [
  { id: "ES", text: "ESPAÑOL" },
  { id: "EN", text: "INGLÉS" },
  { id: "EU", text: "EUSKERA" },
  { id: "CA", text: "CATALÁN" },
  { id: "GA", text: "GALLEGO" },
  { id: "VA", text: "VALENCIANO" },
];

export default ({
  show,
  idFichaLentillas,
  agenteFicha,
  tipoLenteOD,
  tipoLenteOI,
  proveedorLenteOD,
  proveedorLenteOI,
  onAccept,
  onCancel,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [optometristList, setOptometristList] = useState([]);
  const [selectedOptometristId, setSelectedOptometristId] = useState(null);
  const [dniColegiado, setDniColegiado] = useState("");
  const [numColegiado, setNumColegiado] = useState("");
  const [nombreColegiado, setNombreColegiado] = useState("");
  const [apellidosColegiado, setApellidosColegiado] = useState("");
  const [nrsOptica, setNrsOptica] = useState("");
  const [dniPaciente, setDniPaciente] = useState("");
  const [selectedIdiomaId, setSelectedIdiomaId] = useState(
    IDIOMA_OPTIONS[0].id,
  );
  const [normas, setNormas] = useState("");
  const [material, setMaterial] = useState("");
  const [fabricante, setFabricante] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [generatingReceta, setGeneratingReceta] = useState(false);

  const cancel = () => {
    onCancel();
  };

  const selectOptometrist = (option) => {
    setSelectedOptometristId(option ? option.id : null);
    setDniColegiado(option ? option.dni : "");
    setNumColegiado(option ? option.numColegiado : "");
    setNombreColegiado(option ? option.nombre : "");
    setApellidosColegiado(option ? option.apellidos : "");
  };

  const getOptometrists = async () => {
    const response = await post("ListarOptometristas.php", {
      token: userData.token,
      optica: selectedOptic.id,
      completo: 1,
    });
    const list = (response || []).map((e) => ({
      id: e.id,
      text: `${e.nombre} ${e.apellidos}`.trim(),
      dni: e.dni,
      numColegiado: e.numColegiado,
      nombre: e.nombre,
      apellidos: e.apellidos,
    }));
    setOptometristList(list);

    const defaultOptometrist = list.find(
      (o) => o.text === (agenteFicha || "").toUpperCase(),
    );
    selectOptometrist(defaultOptometrist || null);
  };

  const getPopupInfo = async () => {
    const response = await post(
      "/support-extra/receta/ObtenerPopupInfoLentesContacto.php",
      {
        token: userData.token,
        idFichaLC: idFichaLentillas,
      },
    );
    setNrsOptica(response?.nrs || "");
    setDniPaciente(response?.dniPaciente || "");
    setNormas(response?.normas || "");
    setObservaciones(response?.observaciones || "");
  };

  const generarReceta = async () => {
    if (dniPaciente === "") {
      createPopupQuestion(
        "El DNI del paciente no puede estar vacío.",
        () => {
          removePopupQuestion();
        },
        null,
        "Cerrar",
      );
      return;
    }

    setGeneratingReceta(true);
    const response = await post(
      "/support-extra/receta/ObtenerRecetaCGCOOLentesContacto.php",
      {
        token: userData.token,
        idFichaLC: idFichaLentillas,
        idOptometrista: selectedOptometristId,
        dni: dniPaciente,
        normas,
        material,
        fabricante,
        observaciones,
        idioma: selectedIdiomaId,
      },
    );
    setGeneratingReceta(false);

    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Cerrar",
      );
    } else {
      const a = document.createElement("a");
      a.href = `data:application/pdf;base64,${response.fichero}`;
      a.download = `receta_cgcoo_lentes_contacto.pdf`;
      a.click();
      onAccept();
    }
  };

  useEffect(() => {
    if (show) {
      setSelectedIdiomaId(IDIOMA_OPTIONS[0].id);
      setNormas("");
      setMaterial(tipoLenteOD || tipoLenteOI || "");
      setFabricante(proveedorLenteOD || proveedorLenteOI || "");
      setObservaciones("");
      getOptometrists();
      getPopupInfo();
      setTimeout(() => {
        document.querySelector("#" + NORMAS_TEXTAREA_ID)?.focus();
      }, 0);
    }
  }, [show]);

  return show ? (
    <div className="popup-container popup-normal popup-cgcoolc">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">
            Generar receta CGCOO Lentes de Contacto
          </div>
          <img
            src="/images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={cancel}
          />
        </div>
        <div className="popup-body">
          <div className="popup-body-cgcoolc">
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">Optometrista</div>
              <Dropdown
                id={OPTOMETRIST_DROPDOWN_ID}
                tabIndex={1}
                size={0}
                optionList={optometristList}
                op={selectedOptometristId}
                onChange={selectOptometrist}
              />
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">DNI colegiado</div>
              <div className="cgcoolc-row-content">
                <InputData
                  extra="cgcoolc-input-fixed"
                  inactive={true}
                  input={dniColegiado}
                  onChange={setDniColegiado}
                />
                <div className="cgcoolc-inline-group">
                  <div className="label cgcoolc-inline-label">
                    Nº de colegiado
                  </div>
                  <InputData
                    extra="cgcoolc-input-fixed"
                    inactive={true}
                    input={numColegiado}
                    onChange={setNumColegiado}
                  />
                </div>
              </div>
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">Nombre colegiado</div>
              <InputData
                size={0}
                inactive={true}
                input={nombreColegiado}
                onChange={setNombreColegiado}
              />
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">
                Apellidos colegiado
              </div>
              <InputData
                size={0}
                inactive={true}
                input={apellidosColegiado}
                onChange={setApellidosColegiado}
              />
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">NRS óptica</div>
              <InputData
                size={0}
                inactive={true}
                input={nrsOptica}
                onChange={setNrsOptica}
              />
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">DNI paciente</div>
              <div className="cgcoolc-row-content">
                <InputData
                  extra="cgcoolc-input-fixed"
                  tabIndex={2}
                  maxLength={9}
                  input={dniPaciente}
                  onChange={setDniPaciente}
                />
                <div className="label cgcoolc-inline-label">Idioma</div>
                <div className="cgcoolc-dropdown-fill">
                  <Dropdown
                    tabIndex={3}
                    optionList={IDIOMA_OPTIONS}
                    op={selectedIdiomaId}
                    onChange={(item) => setSelectedIdiomaId(item.id)}
                    mandatory={true}
                  />
                </div>
              </div>
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">Normas</div>
              <InputTextArea
                id={NORMAS_TEXTAREA_ID}
                tabIndex={4}
                size={0}
                maxLength={500}
                input={normas}
                onChange={setNormas}
              />
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">Material</div>
              <InputData
                size={0}
                tabIndex={5}
                maxLength={35}
                input={material}
                onChange={setMaterial}
              />
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">Fabricante</div>
              <InputData
                size={0}
                tabIndex={6}
                maxLength={35}
                input={fabricante}
                onChange={setFabricante}
              />
            </div>
            <div className="popup-cgcoolc-contenido-element">
              <div className="label cgcoolc-popup-label">Observaciones</div>
              <InputData
                size={0}
                tabIndex={7}
                maxLength={45}
                input={observaciones}
                onChange={setObservaciones}
              />
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-row-buttons">
            <ButtonIconH
              text="Generar receta"
              disabled={generatingReceta}
              onClick={generarReceta}
            />
            <ButtonIconH text="Cancelar" onClick={cancel} />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
